import { render } from "./AddOriginModal.vue?vue&type=template&id=02005ed9&scoped=true"
import script from "./AddOriginModal.vue?vue&type=script&lang=js"
export * from "./AddOriginModal.vue?vue&type=script&lang=js"

import "./AddOriginModal.vue?vue&type=style&index=0&id=02005ed9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02005ed9"]])

export default __exports__